import React from 'react';
import { useTranslation } from 'react-i18next';
import C01H from '../../../Input/presets/C01H';
import Send from '../../../Icons/Send';
import isValidEmailAddress from '../../../utils/isValidEmailAddress';
import Button from '../../../Button';
import LoadingIndicator from '../../../LoadingIndicator';
import s from './VerificationReminder.scss';
export var VerificationNeeded = function (_a) {
    var email = _a.email, changeEmail = _a.changeEmail, resendEmail = _a.resendEmail, isEmailChangeInProgress = _a.isEmailChangeInProgress, isResendInProgress = _a.isResendInProgress;
    var t = useTranslation().t;
    var isChangeInProgress = isEmailChangeInProgress || isResendInProgress;
    return (React.createElement("div", { className: s['root'] },
        React.createElement("div", { className: s['header'] }, t('siteHeader.verification.verifyEmail')),
        React.createElement("div", { className: s['text'] },
            React.createElement("p", null, t('siteHeader.verification.checkEmail'))),
        React.createElement(Button, { view: "b14", height: "medium", onClick: resendEmail, className: s['resend-button'], disabled: isChangeInProgress, forceHoverStateWhenDisabledBecauseReasons: isResendInProgress }, t(isResendInProgress
            ? 'siteHeader.verification.resending'
            : 'siteHeader.verification.resend')),
        React.createElement("div", { className: s['text-small'] },
            React.createElement("p", null, t('siteHeader.verification.notMe', { email: email }))),
        React.createElement(C01H, { placeholder: t('siteHeader.verification.changeEmail'), submitIcon: isEmailChangeInProgress ? (React.createElement(LoadingIndicator, { view: "spinner", className: s['loader'] })) : (React.createElement(Send, null)), onSubmit: changeEmail, inputValidator: isValidEmailAddress, className: s['email-input'], loading: isChangeInProgress })));
};
VerificationNeeded.displayName = 'VerificationNeeded';
export default VerificationNeeded;
//# sourceMappingURL=VerificationNeeded.js.map